import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ProviderService } from 'src/app/services/provider.service';
import { Merchant,MerchantOperatorContainer } from '../../models/merchant';
import { AuthService } from 'src/app/services/auth-service';
import { Operator } from '../../models/operator';
import { map } from 'highcharts';
import { take } from 'rxjs';
  

@Component({
  selector: 'app-merchant-dropdown',
  templateUrl: './merchant-dropdown.component.html',
  styleUrls: ['./merchant-dropdown.component.css'],
})
export class MerchantDropdownComponent implements OnInit {
  @Input() operator: string = '';
  @Output() onSelectMerchant: EventEmitter<Merchant| null> =
    new EventEmitter<Merchant | null>();

  merchants: Merchant[] = [];
  selectedMerchant: Merchant | null = null;
  selectedValue : string | null = null;
  isLoading = false;
  merchantFromLocalstorage: string | null;
  subscription: any = null;

  constructor(private providerService: ProviderService
    , private authService : AuthService
  ) {  
     this.merchantFromLocalstorage = this.authService.getMerchantNameFromLocalStorage();
     this.selectedValue = this.merchantFromLocalstorage;
     console.log(this.selectedValue)
    }

  ngOnInit() { 
    this.subscription = this.providerService.onChangeOperator$.subscribe(res => { 
     
      this.clear();
      this.operator = res.id;
      this.loadMerchants(this.operator);
    })
  }
 

  loadMerchants(operator: string) { 
    const merchantFromLocalStorage = this.authService.getMerchantNameFromLocalStorage();
    if(merchantFromLocalStorage){ 
        this.selectedValue = merchantFromLocalStorage;   
        this.merchants.push(new Merchant(merchantFromLocalStorage,merchantFromLocalStorage));

        
      const container = new MerchantOperatorContainer();
      container.merchant = this.merchants[0];
      container.operator = new Operator(this.operator,this.operator);

        this.providerService.onFirstMerchantSource.next(container); 
        this.click(this.selectedValue); 
        return;     
    }
 
    this.providerService.loadMerchants(operator).subscribe((merchants) => {
      this.merchants = merchants;
      
      this.merchants.push(new Merchant('All','All'));
    });
  }

 clear(){
   this.selectedValue = null;
   this.selectedMerchant = null;
   this.onSelectMerchant.emit(this.selectedMerchant);
 }

  click(merchant: any) {
    const selectedMerchant = this.merchants.find((c) => c.id == merchant);
    if (!selectedMerchant) {
      return;
    }

    this.selectedValue = merchant;
    this.selectedMerchant = selectedMerchant; 

    this.onSelectMerchant.emit(this.selectedMerchant);
  }

  ngOnDestroy(): void {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}
